<template>
  <div class="imgA">
    <div id="myDivCalen" class="container_row1 p-4">
      <div class="col3">
        <vs-row
          ><vs-spacer />
          <!-- <vs-icon
            v-if="showIcon"
            @click="hideSideBar('myDivCalen')"
            icon="zoom_out_map"
            size="25px"
            color="#111111"
            style="cursor: pointer"
          ></vs-icon> -->

          <vs-button
            radius
            color="success"
            v-if="showIcon"
            @click="hideSideBar('myDivCalen')"
            icon="zoom_out_map"
          ></vs-button>
          <vs-button
            radius
            color="success"
            v-else
            @click="showSideBar"
            type="flat"
            icon="zoom_in_map"
          ></vs-button>
        </vs-row>
      </div>
      <div
        id="div-with-loading-1"
        class="col1_1 layoutmap p-2 carddiv vs-con-loading__container"
      >
        <div class="logo">
          <img
            src="@/assets/images/ajinomoto/logo_ajinomoto.png"
            alt="logo"
            width="100"
          />
        </div>
        <div class="title">
          <h1 class="mt-2" style="font-weight: 600" align="center">
            NONGKHAE FACTORY
          </h1>
        </div>
        <div class="map">
          <img
            src="@/assets/images/ajinomoto/map_2.png"
            alt="logo"
            style="width: 100%"
          />
          <div
            v-for="(item, i) in map"
            :key="i"
            @click="goto(item)"
            style="background: #0000; position: absolute; display:flex;align-items: center;justify-content: center;}"
            :style="{
              width: '50px',
              height: '50px',
              top: item.top + '%',
              left: item.left + '%',
            }"
          >
            <!-- <div
              style="width: 30px; height: 30px; border-radius: 50%"
              :id="'room' + item.id"
            ></div> -->
            <img
              src="@/assets/images/ajinomoto/markup_electic_1.png"
              alt=""
              style="width: 50px"
              :id="'room' + item.id"
            />
            <b-tooltip
              :target="'room' + item.id"
              triggers="hover"
              variant="light"
            >
              <b style="font-size: 1.25rem"> {{ item.name }} Building</b>
              <ul class="list-none">
                <li>
                  Meter Status :
                  <b v-if="item.status >= 1" style="color: #32c040"> ON </b>
                  <b v-else style="color: red"> OFF </b>
                </li>
                <li>
                  Activity Status :
                  <b v-if="item.status == 1" style="color: #32c040"> Active </b>
                  <b v-else style="color: red"> Inactive </b>
                </li>
              </ul>
            </b-tooltip>
          </div>
        </div>
        <div class="data">
          <ul class="list-none padding-div1-text">
            <li class="mb-3">
              <h3 style="font-weight: 600">Power Volume</h3>
            </li>

            <!-- <li style="display: flex; align-items: flex-end" class="mb-3">
              <h1 style="font-weight: 600">
                {{
                  rawData.power_volume == undefined ? "-" : rawData.power_volume
                }}
              </h1>
              <h5 class="ml-3">kWh</h5>
            </li>
            <br />

            <br /> -->
            <li class="mb-3">
              <h2>
                Daily
                <b class="ml-1" style="font-weight: 600">{{
                  rawData.daily_volume == undefined
                    ? "-"
                    : Number(rawData.daily_volume).toLocaleString()
                }}</b>
                <span class="ml-2">kWh</span>
              </h2>
            </li>

            <li class="mb-3">
              <h2>
                Daily
                <b class="ml-1" style="font-weight: 600">{{
                  rawData.power_max == undefined
                    ? "-"
                    : Number(rawData.power_max).toLocaleString()
                }}</b>
                <span class="ml-2">Peak kw</span>
              </h2>
            </li>
            <li class="mb-3">
              <h2>
                Daily
                <b class="ml-1" style="font-weight: 600">{{
                  rawData.power_factor == undefined
                    ? "-"
                    : decimal2_pf.toLocaleString()
                }}</b>
                <span class="ml-2">PF</span>
              </h2>
            </li>
            <!-- <br />
            <li class="mb-3">
              <h4 style="font-weight: 600">Power Factor</h4>
            </li>

            <li style="display: flex; align-items: flex-end" class="mb-3">
              <h1 style="font-weight: 600">
                {{
                  rawData.power_factor == undefined ? "-" : rawData.power_factor
                }}
              </h1>
              <h5 class="ml-3">PF</h5>
            </li> -->
          </ul>
        </div>
      </div>
      <div
        id="div-with-loading-2"
        style="display: flex; align-items: center"
        class="col1_2_1 p-2 carddiv vs-con-loading__container"
      >
        <chart
          style="width: 100%"
          :text="'Power Volume'"
          colorgraph="#EF9BD8"
          :unit="' kWh'"
          :heightgrapg="170"
          :datasets3="rawData.power_volume_Graph"
        />
      </div>
      <div
        id="div-with-loading-3"
        style="display: flex; align-items: center"
        class="col1_2_2 p-2 carddiv vs-con-loading__container"
      >
        <!-- <chart
          :text="'Power Factor'"
          :colorgraph="borderColorP"
          :heightgrapg="130"
          :datasets3="datasets1_2"
        /> -->
        <chart
          style="width: 100%"
          :text="'Power Factor'"
          :unit="' PF'"
          colorgraph="#b85bff"
          :heightgrapg="170"
          :datasets3="rawData.Power_factor_Graph"
        />
      </div>
      <div id="div-with-loading-4" class="col2 p-2 carddiv">
        <div style="display: grid; height: 100%">
          <h2 class="p-1" style="font-weight: 600">Power Consumption</h2>

          <div class="row_powerlabel">
            <ul
              style="overflow-wrap: anywhere"
              v-for="i in namebuding"
              :key="i"
              class="list-none width-buiding"
              align="center"
            >
              <li>
                <h4 :class="'textlist2 gradient' + i.id">
                  {{ i.text }}
                </h4>
              </li>
              <li class="mt-3">
                <h4>
                  <!-- <span>
                  <b style="font-weight: 600; color: #866ed6">Power</b>
                </span> -->
                  <span style="font-size: 1.4rem">
                    <b style="font-weight: 600">{{
                      i.data == 0
                        ? "0"
                        : i.data == undefined
                        ? "0"
                        : i.data.toLocaleString()
                    }}</b>
                    <!-- <b style="font-weight: 600">996909</b> -->
                  </span>
                </h4>
              </li>
              <li class="mt-2"><b>kWh</b></li>

              <!-- <li class="mt-3">
              <h4>
                <b style="font-weight: 600; color: #866ed6">Amps</b>
                <b class="ml-2 mr-2" style="font-weight: 600"> 13.12</b>I
              </h4>
            </li> -->
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="div_item_flex p-4">
      <div
        style="
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        "
        class="width-div-graph-r"
      >
        <div
          id="div-with-loading-5"
          class="carddiv p-2 vs-con-loading__container"
        >
          <chartbar
            :text="'Graph of Power Consumption'"
            :colorgraph="borderColorP"
            :heightgrapg="200"
            :datasets3="rawData.graph_of_power_consumption"
          />
        </div>
        <br />
        <div class="carddiv">
          <chart-stock />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import chart from "./dashboard/chart.vue";
import unaxischart from "./dashboard/chartunaxis.vue";
import chartbar from "./dashboard/chartbar.vue";
import ChartStock from "./dashboard/ChartStock.vue";
import LineChart from "@/components/ChartJs/LineChart.vue";
export default {
  components: { chart, ChartStock, unaxischart, LineChart, chartbar },
  data() {
    return {
      map: [
        {
          id: 0,
          name: "UM ",
          status: 1,
          width: 6,
          height: 6,
          left: 59.5,
          top: 7,
          to: "UM",
        },
        {
          id: 1,
          name: "SP3 ",
          status: 1,
          width: 6,
          height: 6,
          left: 74,
          top: 21,
          to: "SP3",
        },
        {
          id: 2,
          name: "SP2 ",
          status: 1,
          width: 6,
          height: 6,
          left: 65,
          top: 30,
          to: "SP2",
        },
        {
          id: 3,
          name: "SP1 ",
          status: 1,
          width: 6,
          height: 6,
          left: 65,
          top: 18,
          to: "SP1",
        },
        {
          id: 4,
          name: "JP ",
          status: 1,
          width: 6,
          height: 6,
          left: 40,
          top: 54,
          to: "JP",
        },
        {
          id: 5,
          name: "EX1 ",
          status: 1,
          width: 6,
          height: 6,
          left: 77,
          top: 16,
          to: "UM/MN-MDB_EX1",
        },
        {
          id: 6,
          name: "EX2 ",
          status: 1,
          width: 6,
          height: 6,
          left: 70,
          top: 9,
          to: "UM/MN-MDB_EX2",
        },
        {
          id: 7,
          name: "WH ",
          status: 1,
          width: 6,
          height: 6,
          left: 46,
          top: 19,
          to: "WH",
        },
        {
          id: 8,
          name: "GA ",
          status: 1,
          width: 6,
          height: 6,
          left: 50,
          top: 49,
          to: "SP2/SP2-GA",
        },
      ],
      namebuding: [
        { text: "UM", id: 1, data: 0 },
        { text: "SP1", id: 2, data: 0 },
        { text: "SP2", id: 3, data: 0 },
        { text: "SP3", id: 4, data: 0 },
        { text: "JP", id: 5, data: 0 },
        { text: "EX1", id: 6, data: 0 },
        { text: "EX2", id: 7, data: 0 },
        { text: "FWH", id: 8, data: 0 },
        { text: "CWH", id: 9, data: 0 },
        { text: "GC", id: 1, data: 0 },
        { text: "TFTC", id: 2, data: 0 },
        { text: "WWT", id: 3, data: 0 },
        { text: "SW", id: 4, data: 0 },
      ],
      options_select: [
        { text: "Day", value: 1 },
        { text: "Month", value: 2 },
        { text: "Year", value: 3 },
      ],
      item: {
        name: "Power Meter 01",
        id: "211604",
        name_machine: "เครื่องบดอาหาร บด1",
        brand: "BUHLER",
        id_brand: "AHZC66150",
        staff: "ทรรศนะ โชติชื่น",
        tel: "091-0075502",
      },
      rawData: {},
      select_scater: 1,
      nameid: null,
      backgroundColorP: "rgba(20, 153, 242,.1)",
      borderColorP: "rgba(20, 153, 242)",
      backgroundColorW: "rgba(195,157,212,.1)",
      borderColorW: "rgba(195,157,212)",
      backgroundColorL: "rgba(247, 209, 59,.1)",
      borderColorL: "rgba(247, 209, 59)",
      dataB: [],
      dataC: [],
      dataA: [],

      infoNew: {
        id: "ไลน์เครื่องจักร/แผนก",
        mac: "เลขรหัสประจำเครื่อง",
        machine_name: "ชื่อเครื่องจักร",
        model: "ยี่ห้อเครื่องจักร",
        series: "รุ่นเครื่องจักร",
        name: "ผู้รับผิดชอบ",
        phone: "Tel.",
      },
      label: {
        id: "ไลน์เครื่องจักร/แผนก",
        mac: "เลขรหัสประจำเครื่อง",
        machine_name: "ชื่อเครื่องจักร",
        model: "ยี่ห้อเครื่องจักร",
        series: "รุ่นเครื่องจักร",
        name: "ผู้รับผิดชอบ",
        phone: "Tel.",
      },
      showIcon: true,
      delay: 0,
      interval: null,
      decimal2_pf: 0,
    };
  },
  methods: {
    decimalAdjust(type, value, exp) {
      type = String(type);
      if (!["round", "floor", "ceil"].includes(type)) {
        throw new TypeError(
          "The type of decimal adjustment must be one of 'round', 'floor', or 'ceil'."
        );
      }
      exp = Number(exp);
      value = Number(value);
      if (exp % 1 !== 0 || Number.isNaN(value)) {
        return NaN;
      } else if (exp === 0) {
        return Math[type](value);
      }
      const [magnitude, exponent = 0] = value.toString().split("e");
      const adjustedValue = Math[type](`${magnitude}e${exponent - exp}`);
      // Shift back
      const [newMagnitude, newExponent = 0] = adjustedValue
        .toString()
        .split("e");
      return Number(`${newMagnitude}e${+newExponent + exp}`);
    },
    goto(item) {
      console.log(this.$route.path);
      if (this.$route.path.includes("PublicAjinomoto")) {
        this.$router.push({
          path: "/PublicAjinomoto/Machinelist/" + item.to,
        });
      } else {
        this.$router.push({
          path: "/Machinelist/" + item.to,
        });
      }
      //   let path_name = buiding_name.replace(/\s+/g, "");
      // let path_name_machine = item.name.replace(/\s+/g, "");

      // this.$router.push({
      //   path: "/Machinelist/" + item.to,
      // });
      // this.$router.push("/Machinelist/" + buiding_name);
    },
    showSideBar() {
      // location.reload();
      this.showIcon = true;
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        /* Safari */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        /* IE11 */
        document.msExitFullscreen();
      }
    },
    hideSideBar(id) {
      var element = document.getElementById(id);
      this.showIcon = false;
      // Supports most browsers and their versions.
      var requestMethod =
        element.requestFullScreen ||
        element.webkitRequestFullScreen ||
        element.mozRequestFullScreen ||
        element.msRequestFullScreen;

      if (requestMethod) {
        // Native full screen.
        requestMethod.call(element);
      } else if (typeof window.ActiveXObject !== "undefined") {
        // Older IE.
        var wscript = new ActiveXObject("WScript.Shell");
        if (wscript !== null) {
          wscript.SendKeys("{F11}");
        }
      }
    },
    async getDashboardData() {
      const floor10 = (value, exp) => this.decimalAdjust("floor", value, exp);
      try {
        let res = await this.$API.get("ajino-get-dashbooard");
        console.log("ajinomoto dashboard", res.data.message);
        if (res.data.status === true) {
          this.rawData = res.data.message;
          this.decimal2_pf = floor10(this.rawData.power_factor, -2);
          for (let i = 0; i < this.namebuding.length; i++) {
            const el = this.namebuding[i];
            this.namebuding[i].data =
              res.data.message.electric_potential[el.text];
          }
        }
      } catch (error) {}
      for (let i = 1; i < 6; i++) {
        this.$vs.loading.close("#div-with-loading-" + i + " > .con-vs-loading");
      }
      this.interval = setTimeout(async () => {
        await this.getDashboardData();
      }, 1000 * 60 * 10);
    },
  },
  async mounted() {
    for (let i = 1; i < 6; i++) {
      this.$vs.loading({
        container: "#div-with-loading-" + i,
        scale: 0.6,
      });
    }
    await this.getDashboardData();
  },
  beforeDestroy() {
    clearTimeout(this.interval);
  },
};
</script>

<style lang="scss" scoped>
.container_row1 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 0.1fr 1fr 1fr 0.5fr;
  gap: 10px 10px;
  grid-auto-flow: row;
  grid-template-areas:
    "col3 col3 col3"
    "col1_1 col1_1 col1_2_1"
    "col1_1 col1_1 col1_2_2"
    "col2 col2 col2";
}

.col3 {
  grid-area: col3;
}
.col1_1 {
  grid-area: col1_1;
}

.col1_2_1 {
  grid-area: col1_2_1;
}

.col1_2_2 {
  grid-area: col1_2_2;
}

.col2 {
  grid-area: col2;
}

.width-div {
  width: calc(100% / 3);
}
.width-div-graph-r {
  width: 100%;
}
.width-50 {
  width: 50%;
}
.heigth-50 {
  height: 50%;
}
.textlist2 {
  /* background: linear-gradient(90deg, #00C9FF 0%, #92FE9D 100%); */
  border-radius: 20px;
  padding: 5%;
  margin: 0 5%;
  font-size: 1rem;
  white-space: nowrap;
  font-weight: 600;
}
.gradient1 {
  background: linear-gradient(
    90deg,
    rgb(247, 141, 84) 0%,
    rgb(245, 185, 82) 100%
  );
  /* font-weight: 500; */
}
.gradient2 {
  background: linear-gradient(90deg, #77d8f3 0%, #92fe9d 100%);
}
.gradient3 {
  background: linear-gradient(90deg, #af80f1 0%, #e795db 100%);
}
.gradient4 {
  background: linear-gradient(90deg, #fa7ba5 0%, #fa7ba5 100%);
}
.gradient5 {
  background: linear-gradient(90deg, #a499da 0%, #92fe9d 100%);
}
.gradient6 {
  background: linear-gradient(90deg, #77d8f3 0%, #929bef 100%);
}
.gradient7 {
  background: linear-gradient(90deg, #ffe9d0 0%, rgb(245, 185, 82) 100%);
}
.gradient8 {
  background: linear-gradient(90deg, #b6c1d4 0%, #ec68b1 100%);
}
.gradient9 {
  background: linear-gradient(90deg, #a499da 0%, #47aea3 100%);
}
.width-buiding {
  width: calc(100% / 13);
  // background: #92fe9d;
  margin: 5px;
}
.row_powerlabel {
  display: flex;
  // flex-wrap: wrap;
}
.select-date {
  display: flex;
  align-items: center;
  color: #808080;
  flex-wrap: wrap;
  .date-range {
    display: flex;
    align-items: center;
    gap: 5px;
    border: 1px #808080 solid;
    border-radius: 30px;
    padding: 8px;
    background-color: #fff;
  }
}
.div-space {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.imgA {
  padding: 0;
  margin: -14px;
  background-image: url("../../../../assets/images/ajinomoto/bg.jpeg");
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  // height: 100vh;

  color: #000;
}

:fullscreen {
  padding: 0;
  margin: 0;
  background-image: url("../../../../assets/images/ajinomoto/bg.jpeg");
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  // height: 100vh;

  color: #000;
  // .container_row1 {
  //  margin: 20px;
  // }
}

.div-graph {
  width: 50%;
  height: 100%;
}
.div_item_flex {
  display: flex;
}
.padding-10 {
  padding: 10px;
}
// .padding-20 {
//   padding: 20px;
// }
.list-none {
  list-style: none;
}
.div-row {
  display: flex;
  width: 100%;
}
.div-row-grapg {
  display: flex;
  width: 100%;
  height: 50%;
}
.widthdiv1 {
  width: 28%;
  margin-right: 20px;
}
.widthdiv1-1 {
  width: 28%;
  // margin-right: 20px;
}
.widthdiv1-2 {
  width: 28%;
  // margin-right: 20px;
}
.widthdiv {
  width: 72%;
}
.width_item2 {
  width: 35%;
}
.width_div3 {
  margin-left: 20px;
  // display: grid;
}
.margin-ri {
  margin-right: 20px;
}
.carddiv {
  height: auto;
  background-color: rgba(255, 255, 255, 0.75);
  border-radius: 20px;
  display: block;
  //   -webkit-box-shadow: 0 4px 25px 0 rgb(0 0 0 / 10%);
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.1);
  //   -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.layoutmap {
  // width: 100%;
  display: grid;
  align-items: center;
  grid: 100px auto/ 100px auto auto auto;
  .logo {
    grid-row: 1/2;
    grid-column: 1/2;
  }
  .title {
    grid-row: 1/2;
    grid-column: 3/5;
  }
  .map {
    grid-row: 1/3;
    grid-column: 1/4;
    position: relative;
  }
  .data {
    position: absolute;
    bottom: 0;
    right: 0;
  }
}

.li-div2 {
  display: flex;
  align-items: center;
}
.div2st {
  position: relative;
  width: 30%;
}
.div3st1 {
  position: relative;
  width: 40%;
}
.div3st2 {
  position: relative;
  width: 70%;
}
.item2_flex {
  display: flex;
  white-space: nowrap;
}
.item2_div1 {
  font-size: 0.8rem;
}
.item2_div2 {
  /* margin-top: 10px;
  margin-right: 10px; */
  /* float: right; */
  display: flex;
  justify-content: flex-end;
  // justify-content: center;
  font-size: 0.1rem;
}
.text-temp2 {
  font-size: 2.5rem;
}
.img-div2 {
  width: 70%;
  margin-top: 15px;
  margin-left: 15px;
}
.img-div3 {
  width: 100%;
  margin-top: 15px;
  margin-left: 15px;
}
.text-div2 {
  position: absolute;
  top: 10px;
}
.text_b {
  font-weight: 600;
}
.text_temp_small {
  font-size: 1.2rem;
  font-weight: 600;
}
.container-fluid {
  display: flex;
  justify-content: center;
}
// .header-top1 {
// margin-bottom: 5em;
// margin: 20px;
// }
.header-top2 {
  margin-top: 3em;
}
.div_item_flex3_1_1 {
  width: 50%;
}
.div_item_flex3_1_2 {
  // width: 100%;
  margin-left: 20px;
  height: 50%;
}
.padding-div1-text {
  padding: 20px;
}
.font-color-black {
  color: #4d4f5c;
}
// @media (min-width: 768px) and (max-width: 1190px) {
//   .container_row1 {
//     display: flex;
//     flex-direction: column;
//   }
// }

@media only screen and (max-width: 700px) {
  .container_row1 {
    grid-template-columns: 100%;
    grid-template-rows: auto auto;
    // gap: 10px 10px;
    grid-auto-flow: row;
    grid-template-areas:
      "col1_1"
      "col1_2_1"
      "col1_2_2"
      "col2";
  }
  .margin-ri {
    margin-right: 0;
    margin-bottom: 20px;
  }
  .div-row {
    flex-wrap: wrap;
  }
  .div_item_flex {
    flex-wrap: wrap;
  }
  .widthdiv {
    width: 100%;
  }
  .width-div {
    width: 100%;
  }

  .widthdiv1 {
    width: 100%;
    margin-right: 0;
    margin-bottom: 20px;
  }
  .header-top1 {
    margin-bottom: 2em;
    margin-top: 1em;
  }
  .header-top2 {
    margin-top: 0;
  }
  .width_div3 {
    margin-left: 0;
  }
  .div_item_flex3_1_1 {
    width: 100%;
  }
  .div_item_flex3_1_2 {
    width: 100%;
    margin-left: 0;
    margin-top: 20px;
    height: auto;
  }
  .div-graph {
    width: 100%;
  }
  .div-space {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .row_powerlabel {
    flex-wrap: wrap;
    justify-content: center;
  }
  .width-buiding {
    width: calc(100% / 4);
  }
  .col3 {
    display: none;
  }
  .layoutmap {
    // width: 100%;
    display: grid;
    align-items: center;
    grid: 100px auto auto auto/ 100px auto;
    .logo {
      grid-row: 1/2;
      grid-column: 1/2;
    }
    .title {
      grid-row: 3/4;
      grid-column: 1/3;
    }
    .map {
      grid-row: 1/3;
      grid-column: 1/3;
      position: relative;
    }
    .data {
      grid-row: 4/5;
      grid-column: 2/3;
      position: unset;
    }
  }
}
</style>